import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Card, CardContent } from '../ui/card';

const FreightFooter = ({ freightCharges, setFreightCharges }) => (
  <Card>
    <CardContent className="p-4">
      <div className="flex items-center gap-4">
        <Label className="text-sm font-semibold text-gray-700">Freight Charges</Label>
        <Input type="number" min="0" step="0.01" value={freightCharges}
          onChange={e => setFreightCharges(e.target.value)}
          placeholder="0" className="h-9 w-40 text-right text-sm"
          onWheel={e => e.target.blur()} data-testid="pr-freight-charges" />
      </div>
    </CardContent>
  </Card>
);

export default FreightFooter;
